import React, { Component } from 'react';
import ClipLoader from 'react-spinners/ClipLoader'
import Modal from 'react-modal'
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '350px',
    height                 : '200px',
    border: 0,
    padding: 33,
    borderRadius: 20
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.4)'
  }
};
//Modal.setAppElement('#root')

class DownloadModal extends Component {
  constructor() {
    super();
 
    this.state = {
      modalIsOpen: false
    };
  }

  openModal = () => {
    this.setState({modalIsOpen: true});
  }
 
  afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    //this.subtitle.style.color = '#f00';
  }

  componentWillReceiveProps(nextProps) {
    this.setState({modalIsOpen: nextProps.modalIsOpen})
  }
  closeModal = () => {
    this.props.closeModal();
    this.setState({modalIsOpen: false});
  }
  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          shouldFocusAfterRender={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={true}
        >
          <div style={{backgroundColor:"white", fontSize:15, textAlign:"center"}}>
          <h5>While your file is downloading...</h5>
          <span>Please check us out on <a href="https://www.producthunt.com/posts/growjo" target="_blank">Product Hunt</a></span>
          <div style={{display:"block", marginTop:28}}>
            <ClipLoader
              sizeUnit={"px"}
              size={40}
              color={'grey'}
              loading={'true'}
              display={'block'}
            />
          </div>
          </div>
          </Modal>
      </React.Fragment>
    );
  }
}

export default DownloadModal;





// WEBPACK FOOTER //
// ./client/src/components/downloadModal.js